/** Высота строки таблицы в пикселях — фиксированная, одинаково на всех устройствах */
const TABLE_ROW_HEIGHT_PX = 56;

export function getTableRowHeightPx(): number {
  return TABLE_ROW_HEIGHT_PX;
}
